<div id="balance-container" [ngClass]="{ 'is-mobile': isMobile }">
  <div class="balance-section">
    <span class="text">
      <p id="balance-title">{{ 'User.Balance.Title' | translate }}</p>
      <p id="balance-amount">
        {{ userBalance !== null ? (userBalance | number : '1.2-2') : '----' }}
      </p>
    </span>
    <span
      id="reload-btn"
      class="icon reload icon-reload"
      (click)="reloadBalance()"
    ></span>
  </div>
  <div class="search-btn">
    <ng-content></ng-content>
  </div>
</div>
